<div *ngIf="showNewsTicker">
  <news-ticker [theme_id]="session?.user?.theme_id"></news-ticker>
</div>
<nav-header></nav-header>
<router-outlet></router-outlet>
<nav-footer></nav-footer>
